import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import MetaTags from "@/components/MetaTags/index";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Canvas = dynamic(() => import("@/components/Canvas"), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("@/components/Canvas")]
  }
});

/**
 * getIdKey.
 *
 * @param {string} slug
 */
function getIdKey(slug) {
  return `canvas_${slug}`;
}
export var __N_SSP = true;
export default function CanvasPage(_ref) {
  let {
    title,
    metatags
  } = _ref;
  const router = useRouter();
  const key = useMemo(() => {
    return getIdKey(router.query.slug);
  }, [router]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MetaTags, _objectSpread({}, metatags)), /*#__PURE__*/_jsx(Canvas, {
      idKey: key,
      title: title
    })]
  });
}